<template>
    <div class="pratice-communication-and-marketing-post-content" id="identidade-verbal-na-pratica-post" data-search-anchor>           

        <div class="pratice-colums-communication-and-marketing-post-wrapper"> 
            <div class="pratice-communication-and-marketing-container">
                <p class="pratice-post-paragraph-title">{{ praticePostParagraphTitle }}</p>
                <p class="pratice-post-paragraph">{{ praticePostParagraph1 }}</p>                        
                <p class="pratice-post-paragraph">{{ praticePostParagraph2 }}</p>                
                <p class="pratice-post-paragraph">{{ praticePostParagraph3 }}</p>                         
            </div>

            <div class="pratice-communication-and-marketing-tips-container">
                <p class="pratice-tips-paragraph-tilte">{{ praticeTipsParagraphTitle }}</p>
                <p class="pratice-tips-cmp-paragraph">{{ praticeTipsParagraph1 }}</p>                
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph2 }}</p>
                <ThreeCircles />
                <p class="pratice-tips-cmp-paragraph">{{ praticeTipsParagraph3 }}</p>                
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph4 }}</p>
                <TwoCircles />
                <p class="pratice-tips-cmp-paragraph">{{ praticeTipsParagraph5 }}</p>
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph6 }}</p>
                <ThreeCircles />

                <div class="pratice-tips-legend-wrapper">
                  <div class="pratices-tips-legend-paragraph">
                    <p class="pratices-legend-paragraph">{{ praticeTipsParagraph7 }}</p>
                    <p class="pratices-legend-paragraph">{{ praticeTipsParagraph8 }}</p>
                  </div>
                  
                  <div class="pratice-legend-circles">
                    <div class="pratice-line">
                      <LineGradient />
                    </div>
                    <div class="pratice-circles">
                      <ThreeCircles /><TwoCircles /><OneCircle /><BlankCircles />
                    </div>                   
                  </div>                  
                </div>           
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import BlankCircles from '@/assets/icons/BlankCircles.vue'
import LineGradient from '@/assets/icons/LineGradient.vue'
import OneCircle from '@/assets/icons/OneCircle.vue'
import ThreeCircles from '@/assets/icons/ThreeCircles.vue'
import TwoCircles from '@/assets/icons/TwoCircles.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import PraticePageMixin from '@/mixins/pratice-page-mixin'
import { PraticePageStore } from '@/store/verbal-identity-page/pratice-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({components: { ThreeCircles, LineGradient, TwoCircles, OneCircle, BlankCircles }})
export default class PraticeCommunicationAndMarketingPostSection extends Mixins(PraticePageMixin) {
  praticePageStore: PageStoreContract = getModule(PraticePageStore, this.$store)

  get praticePostParagraphTitle(): string {
    return this.getElementText(3, 0)
  }

  get praticePostParagraph1(): string {
    return this.getElementText(3, 1)
  }

  get praticePostParagraph2(): string {
    return this.getElementText(3, 2)
  }

  get praticePostParagraph3(): string {
    return this.getElementText(3, 3)
  }

  get praticeTipsParagraphTitle(): string {
    return this.getElementText(3, 4)
  }

  get praticeTipsParagraph1(): string {
    return this.getElementText(3, 5)
  }

  get praticeTipsParagraph2(): string {
    return this.getElementText(3, 6)
  }

  get praticeTipsParagraph3(): string {
    return this.getElementText(3, 7)
  }

  get praticeTipsParagraph4(): string {
    return this.getElementText(3, 8)
  }

  get praticeTipsParagraph5(): string {
    return this.getElementText(3, 9)
  }

  get praticeTipsParagraph6(): string {
    return this.getElementText(3, 10)
  }

  get praticeTipsParagraph7(): string {
    return this.getElementText(3, 11)
  }

  get praticeTipsParagraph8(): string {
    return this.getElementText(3, 12)
  }

  async getPraticePage(): Promise<void> {
    await this.praticePageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.praticePageStore.isLoading) {
      await this.getPraticePage()
    }
  }
}
</script>

<style lang="scss">
.pratice-communication-and-marketing-post-content {
  display: grid;
  justify-content: center;    
  max-width: 1032px;
}

.pratice-colums-communication-and-marketing-post-wrapper {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 495px);
  column-gap: 42px;
  margin-top: 37px; 
}

.pratice-communication-and-marketing-container {
  width: 506px;
  height: 735px;
  border-radius: 16px;    
  color: white;
  background: linear-gradient(90deg, #0079FD -37.91%, #2D51FB 20.11%, #5A29FA 78.13%, #8800F8 137.91%);
}

.pratice-communication-and-marketing-tips-container {
  width: 506px;
  height: 735px;    
}

.pratice-post-paragraph {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;  
  margin:0 31px 22px 33px;
}

.pratice-post-paragraph:last-of-type{
  white-space: pre;
}

.pratice-post-paragraph-title {
  font-weight: 700;
  font-size: 20px;  
  line-height: 24px;
  margin:31px 0 35px 29px;
}

.pratice-post-paragraph-title {
  white-space: pre;
}

.pratice-tips-paragraph-tilte {
  font-weight: 800;
  font-size: 20px;  
  line-height: 17px;
  margin-top: 31px;
  margin-bottom: 48px;
  white-space: pre; 
  color: rgba(149, 149, 149, 1);
}

.pratice-tips-cmp-paragraph {
  font-weight: 400;
  font-size: 16px;  
  line-height: 24px;
  margin-bottom: 0; 
  white-space: pre; 
  color: rgba(149, 149, 149, 1);
}

.pratice-tips-cmp-paragraph:nth-child(5) {
  margin-top: 52px;
}

.pratice-tips-cmp-paragraph:nth-child(8) {
  margin-top: 74px;
}

.pratice-tips-bold-paragraph{
  font-weight: 800;
  font-size: 16px;  
  line-height: 24px;
  margin: 0;
  color: rgba(149, 149, 149, 1);
}

.pratice-tips-legend-wrapper {
  display: flex;
  flex-direction: column;  
  margin-top: 66px;
}

.pratices-tips-legend-paragraph {
  display: flex;
  gap: 118px;              
}

.pratices-legend-paragraph {
  display: flex;
  font-weight: 600;
  font-size: 16px;  
  line-height: 100%;
  margin-top: 0;
  margin-bottom: 7px;
  color: rgba(149, 149, 149, 1);
}

.pratice-legend-circles {
  display: flex;
  flex-direction: column;
  gap: 12px;  
}

.pratice-circles{
  display: flex;
  gap: 74px;
}

</style>
